import { termsOfUsePolicies } from "@app/constants/policies";
import { Fragment } from "react";

const TermsSectionContent = () => {

  return (
    <div className="flex flex-col gap-y-8 md:max-w-[720px]">
      {termsOfUsePolicies.map((content) => (
        <div key={content.title} className="flex flex-col gap-y-2"> 
          <span className="h5 text-text-color-high-em">{content.title}</span>
          <span className="text-body-md text-text-color-mid-em">{content.body.split('\<br/>').map((bodyContent) => (
            <Fragment key={bodyContent}>
              {bodyContent}
              <br/>
            </Fragment>
          ))}</span>
        </div>
      ))}
    </div>
  );
};

export default TermsSectionContent;
